import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-email-export',
  template: require('./email-export.component.html')
})
export class EmailExportComponent {
  @Input() exportType: string;
  @Input() exportFn: (email: string) => Promise<any>;

  email = '';

  constructor (
    public activeModal: NgbActiveModal,
    private messagesService: MessagesService,
    private translateService: TranslateService
  ) {}

  submit (): void {
    this.exportFn(this.email)
      .then(() => {
        this.messagesService.show(
          this.translateService.instant('EXPORT_SPACE.EXPORT_EMAIL_CONFIRM', { email: this.email }),
          'success'
        );
        this.activeModal.close();
      })
      .catch((err: any) => this.messagesService.error(err));
  }
}
